export const getAllDistrictAdmin = (obj) => ({
	type: "GET_ALL_DISTRICT_ADMIN",
	obj,
});

export const getAllDistrictAdminSuccess = (data) => ({
  type: "GET_ALL_DISTRICT_ADMIN_SUCCESS",
  data,
});

export const getAllDistrictAdminFail = (error) => ({
  type: "GET_ALL_DISTRICT_ADMIN_FAIL",
  error,
});

export const addDistrictAdmin = (obj) => ({
  type: "ADD_DISTRICT_ADMIN",
  obj,
});

export const addDistrictAdminSuccess = (data) => ({
  type: "ADD_DISTRICT_ADMIN_SUCCESS",
  data,
});

export const addDistrictAdminFail = (error) => ({
  type: "ADD_DISTRICT_ADMIN_FAIL",
  error,
});

export const resetAddDistrictAdmin = (error) => ({
  type: "RESET_ADD_DISTRICT_ADMIN",
  error,
});

export const getDistrictAdminDetails = (obj) => ({
  type: "GET_DISTRICT_ADMIN_DETAILS",
  obj,
});

export const getDistrictAdminDetailsSuccess = (data) => ({
  type: "GET_DISTRICT_ADMIN_DETAILS_SUCCESS",
  data,
});

export const getDistrictAdminDetailsFail = (error) => ({
  type: "GET_DISTRICT_ADMIN_DETAILS_FAIL",
  error,
});

export const updateDistrictAdmin = (obj) => ({
  type: "UPDATE_DISTRICT_ADMIN",
  obj,
});

export const updateDistrictAdminSuccess = (data) => ({
  type: "UPDATE_DISTRICT_ADMIN_SUCCESS",
  data,
});

export const updateDistrictAdminFail = (error) => ({
  type: "UPDATE_DISTRICT_ADMIN_FAIL",
  error,
});

export const resetUpdateDistrictAdmin = () => ({
  type: "RESET_UPDATE_DISTRICT_ADMIN",
});